import { namesStartingWithLetter } from "./variables";

function filterData(letter, arr) {
	const filtered = arr.filter((o) => o.phone.startsWith(letter));
	const names = filtered.map((o) => o.phone);
	const catalogs = filtered
		.filter((o) => o.catalogs)
		.flatMap((o) => o.catalogs);

	const listContainer = document.querySelector(".brendy__list");
	listContainer.innerHTML = "";

	if (!names.length) {
		listContainer.textContent = "No elements";
		return;
	}

	if (catalogs.length) {
		names.forEach((name) => {
			const h3 = document.createElement("h3");
			h3.textContent = name;
			listContainer.appendChild(h3);
		});

		catalogs.forEach((catalog) => {
			const li = document.createElement("li");
			li.innerHTML = `<a href="${catalog}" target="_blank">${catalog.split("/").pop()}</a>`;
			listContainer.appendChild(li);
		});
	} else {
		const ul = document.createElement("ul");
		names.forEach((name) => {
			const ul_li = document.createElement("li");
			ul_li.textContent = name;
			ul.appendChild(ul_li);
		});
		listContainer.appendChild(ul);
	}
}

export default filterData;
